import React from 'react';
import { HashRouter, Routes, Route, Navigate } from 'react-router-dom';
import OptionsTrading from './OptionsTrading';
import NormalTradingV1 from './NormalTradingV1';
import NormalTradingV1Master from './NormalTradingV1Master';
import NormalTradingV1Sold from './NormalTradingV1Sold';
import NormalTradingV1Testing from './NormalTradingV1Testing';
import NormalTradingV1TestingMaster from './NormalTradingV1TestingMaster';
import TwoHourTrading from './TwoHourTrading';
import TradingLedgerPage from './TradingLedgerPage';
import LiveErrorBoundary from './LiveErrorBoundary';
import DegenDashboard from './degen/DegenDashboard';
import DegenDailyReport from './degen/DegenDailyReport';
import CncDegenDashboard from './degen/CncDegenDashboard';
import AppShell from './AppShell';
import { ThemeProvider } from './ThemeContext';
import './theme.css';
import './App.css';

const App = () => (
  <ThemeProvider>
    <HashRouter>
      <Routes>
        <Route element={<AppShell />}>
          <Route path="/" element={<OptionsTrading />} />
          <Route path="/NormalTrading" element={<LiveErrorBoundary><NormalTradingV1 /></LiveErrorBoundary>} />
          <Route path="/NormalTrading/Master" element={<LiveErrorBoundary><NormalTradingV1Master /></LiveErrorBoundary>} />
          <Route path="/NormalTrading/Sold" element={<LiveErrorBoundary><NormalTradingV1Sold /></LiveErrorBoundary>} />
          <Route path="/NormalTrading/Testing" element={<LiveErrorBoundary><NormalTradingV1Testing /></LiveErrorBoundary>} />
          <Route path="/NormalTrading/Testing/Master" element={<LiveErrorBoundary><NormalTradingV1TestingMaster /></LiveErrorBoundary>} />
          <Route path="/NormalTradingV1" element={<Navigate to="/NormalTrading" replace />} />
          <Route path="/TwoHourTrading" element={<TwoHourTrading />} />
          <Route path="/DegenDashboard" element={<DegenDashboard />} />
          <Route path="/DegenDashboard/Report" element={<DegenDailyReport />} />
          <Route path="/Report" element={<DegenDailyReport />} />
          <Route path="/degen/report" element={<Navigate to="/Report" replace />} />
          <Route path="/CncDegenDashboard" element={<CncDegenDashboard />} />
          <Route path="/cnc-degen" element={<Navigate to="/CncDegenDashboard" replace />} />
          <Route path="/degen" element={<Navigate to="/DegenDashboard" replace />} />
          <Route path="/ledger" element={<Navigate to="/ledger/normal" replace />} />
          <Route path="/ledger/:mode" element={<TradingLedgerPage />} />
        </Route>
      </Routes>
    </HashRouter>
  </ThemeProvider>
);

export default App;
